export const environment = {
  production: true,
  apiUrl: '',
  devMode: false,
  userIdle: 600,
  userTimeout: 30,
};
